import { ImageEditEventHandlers, ImageEditEvents } from '../events';
import { Emitter } from 'nanoevents';

export function registerLogger(eventBus: Emitter<ImageEditEventHandlers>) {
    const tag = '[ImageEditManager]';
    const error = (...messages: any[]) => window.log.error(tag, ...messages);
    const info = (...messages: any[]) => window.log.info(tag, ...messages);

    eventBus.on(ImageEditEvents.WillCreateImages, (blobs) => {
        info('start creating image', '|', `total=${blobs.length}`);
    });

    eventBus.on(ImageEditEvents.DidCreateImages, (images) => {
        info('done creating image', '|', `success=${images.length}`);
    });

    eventBus.on(ImageEditEvents.CreateImageError, (err) => {
        error('failed to create image:', err);
    });

    eventBus.on(ImageEditEvents.ValidateError, (err) => {
        info('insert an invalid image:', err);
    });

    eventBus.on(ImageEditEvents.UploadError, (err) => {
        error('failed to upload image:', err);
    });

    eventBus.on(ImageEditEvents.UploadGifError, (err) => {
        error('failed to upload gif:', err);
    });
}
